import { cva } from 'class-variance-authority'

import { Button, ButtonProps } from '@/components/lemmala-design-system/button/button'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

const actionItemVariants = cva('w-fit rounded', {
  variants: {
    urgent: {
      true: 'bg-semantic-danger-50 text-semantic-danger-500 hover:bg-semantic-danger-100',
    },
  },
})

type ActionItemProps = {
  text: React.ReactNode
  icon: React.ReactNode
  onClick: ButtonProps['onClick']
  urgent?: boolean
}

export const ActionItem = ({ text, icon, onClick, urgent }: ActionItemProps) => {
  return (
    <Button
      size='sm'
      variant='outline'
      className={actionItemVariants({ urgent })}
      onClick={(e) => {
        e.stopPropagation()
        onClick?.(e)
      }}
    >
      <TextWithIcon text={text} iconPosition='start' icon={icon} />
    </Button>
  )
}
